import type {
	ReceiveDecoratedVendorAction,
	ReceiveVendorAction,
	ResetVendorAction,
	VendorActionTypes,
} from '@typings/vendor/actionTypes';
import type { Vendor as VendorType } from '../../../types/redux/vendor';
import Vendor from '../../decorators/vendor';

/** @internal */
export const VENDOR_LOADED = '@fe-marketplace/vendor/loaded';
/** @internal */
export const VENDOR_DECORATED_LOADED =
	'@fe-marketplace/vendor/decorated-loaded';
/** @internal */
export const VENDOR_RESET = '@fe-marketplace/vendor/reset';

/** @internal */
export const initialState: VendorType = {
	vendor: null,
	vendorRaw: null,
};

export default function reducer(
	state: Redux.State['vendor'] = initialState,
	action: VendorActionTypes,
) {
	switch (action.type) {
		case VENDOR_LOADED:
			return {
				...state,
				vendor: new Vendor(action.payload),
				vendorRaw: action.payload,
			};
		case VENDOR_DECORATED_LOADED:
			return {
				...state,
				vendor: action.payload.vendor,
				vendorRaw: action.payload.vendorRaw,
			};
		case VENDOR_RESET:
			return initialState;
		default:
			return state;
	}
}

export interface ReceiveVendorPayload {
	data: {
		storefront: Vendor.Raw;
	};
}

export const receiveVendor = (
	response: ReceiveVendorPayload,
): ReceiveVendorAction => ({
	type: VENDOR_LOADED,
	payload: response.data.storefront,
});

export const receiveDecoratedVendor = (
	vendor: Vendor.Decorated,
	vendorRaw: Vendor.Raw,
): ReceiveDecoratedVendorAction => ({
	type: VENDOR_DECORATED_LOADED,
	payload: { vendor, vendorRaw },
});

export const resetVendor = (): ResetVendorAction => ({ type: VENDOR_RESET });
